import { Component, OnInit } from '@angular/core';
import { Context } from 'src/app/shared/models/context';
import { OrgChart } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { EmployeeService } from 'src/app/shared/services/employee.service';

@Component({
  selector: 'app-org-chart',
  templateUrl: './org-chart.component.html',
  styleUrls: ['./org-chart.component.scss']
})
export class OrgChartComponent implements OnInit {
  public orgChartData: OrgChart[]=[];
  public context: Context;
  private subscription: any
  constructor(
    private employeeService: EmployeeService,
    private authService:AuthService
  ) { }

  ngOnInit(): void {
    this.subscription = this.authService.getContext().subscribe(context => {
      if (context?.employeeId) {
        this.context = context;
        this.getOrgChart();
      }
    });
  }

  private getOrgChart(): void {
    this.employeeService.getOrgChart(this.context.employeeId).subscribe({
      next: (orgChart) => (this.orgChartData = orgChart),
      error: (err) => console.error('Failed to load org chart', err),
    });
  } 
  
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  // nodes: any = [
  //   {
  //     name: 'Sundar Pichai',
  //     cssClass: 'ngx-org-ceo',
  //     image: 'assets/node.svg',
  //     title: 'Chief Executive Officer',
  //     childs: [
  //       {
  //         name: 'Thomas Kurian',
  //         cssClass: 'ngx-org-ceo',
  //         image: 'assets/node.svg',
  //         title: 'CEO, Google Cloud',
  //       },
  //       {
  //         name: 'Susan Wojcicki',
  //         cssClass: 'ngx-org-ceo',
  //         image: 'assets/node.svg',
  //         title: 'CEO, YouTube',
  //         childs: [
  //           {
  //             name: 'Beau Avril',
  //             cssClass: 'ngx-org-head',
  //             image: 'assets/node.svg',
  //             title: 'Global Head of Business Operations',
  //             childs: []
  //           },
  //           {
  //             name: 'Tara Walpert Levy',
  //             cssClass: 'ngx-org-vp',
  //             image: 'assets/node.svg',
  //             title: 'VP, Agency and Brand Solutions',
  //             childs: []
  //           },
  //           {
  //             name: 'Ariel Bardin',
  //             cssClass: 'ngx-org-vp',
  //             image: 'assets/node.svg',
  //             title: 'VP, Product Management',
  //             childs: []
  //           }
  //         ]
  //       },
  //       {
  //         name: 'Jeff Dean',
  //         cssClass: 'ngx-org-head',
  //         image: 'assets/node.svg',
  //         title: 'Head of Artificial Intelligence',
  //         childs: [
  //           {
  //             name: 'David Feinberg',
  //             cssClass: 'ngx-org-ceo',
  //             image: 'assets/node.svg',
  //             title: 'CEO, Google Health',
  //             childs: []
  //           }
  //         ]
  //       }
  //     ]
  //   },
  
  // ];
  

}
